import React, { useState, useEffect } from 'react';
import { handleApiExceptions, generate_query_set, alertify } from '../../../app_methods';
import { ContentCard, MerchantModal, PaginationKaBaap } from '../../Common';
import { EaseTable } from '../../../libs/EaseTable';
import { isMobile } from 'react-device-detect';
import { getMerchantsTableColumns, merchantsFilterNodes } from './constants';
import { Merchant } from '../../../models';
import { Button, Icon, Alert, Spin, Descriptions } from 'antd';
import { CommissionModal } from './commission_modal';
import { InstaCommissionModal } from './insta_commission_modal';
// import KYCModal from './kyc_modal';
import { MerchantDetailsDrawer } from './details_drawer';
import { default as AllotedConnectedBankingDrawer } from './alloted_connected_banking_drawer';
import { connect } from 'react-redux';
import { updateCurrentUserAction } from '../../../redux/actions';
import { MerchantInsightsDrawer } from './insights_drawer';
import { PermissionHoc } from '../../HOC';
import { ResendPasswordModal } from '../../Common/ResendPasswordModal';
import { Text4 } from "../../../styles";
import { DeactivateMerchantModal } from '../../Common/DeactivateMerchantModal';


const CreatePermissableButton = PermissionHoc(Button, "MERCHANTS_WRITE", { is_component: true, fallbackComponent: null })

const MerchantList = (props) => {
    const [isTableLoading, setIsTableLoading] = useState(false);
    const [pagination, setPagination] = useState({
        pageSize: 15,
        current: 1,
        hasNext: true,
        showing: { from: 1, to: 15 }
    });
    const [filters, setFilters] = useState({});
    const [merchants, setMerchants] = useState([]);
    const [selectedMerchant, setSelectedMerchant] = useState({});
    const [isSaving, setIsSaving] = useState(false);
    const [isUpdatingCommission, setIsUpdatingCommission] = useState(false);
    const [isUploadingKYC, setIsUploadingKYC] = useState(false);
    const [isFetchingKycURL, setIsFetchingKycURL] = useState(false);
    const [showMerchantModal, setShowMerchantModal] = useState(false);
    const [showCommissionModal, setShowCommissionModal] = useState(false);
    const [showInstaCommissionModal, setShowInstaCommissionModal] = useState(false);
    const [showKYCModal, setShowKYCModal] = useState(false);
    const [showDetailsDrawer, setShowDetailsDrawer] = useState(false);
    const [showInsightsDrawer, setShowInsightsDrawer] = useState(false);
    const [showResendPassword, setShowResendPassword] = useState(false);
    const [showResendPasswordModal, setShowResendPasswordModal] = useState(false);
    const [kycMerchantID, setKycMerchantID] = useState("");
    const [Deactivate, setDeactivate] = useState(false);
    const [showDeactivateModal, setShowDeactivateModal] = useState(false);
    const [showAllotedConnectedBankingDrawer, setAllotedConnectedBankingDrawer] = useState(false);
    const is_enable_fund_allotment = props?.current_user?.scba || false
    const fetchMerchants = async (_pagination = pagination, _filters = filters) => {
        if (!props.current_user.key) return;
        setIsTableLoading(true);
        const response = await Merchant.list_v2({ ...{ pageSize: _pagination.pageSize, current: _pagination.current }, ..._filters });
        if (!response.success) {
            setIsTableLoading(false);
            handleApiExceptions(response);
            return;
        }
        setMerchants(generate_query_set(Merchant, response.data.results));
        setPagination({  ..._pagination, ...response.data.pagination });
        setIsTableLoading(false);
    };

    const openKYCPage = async (merchant = {}) => {
        setSelectedMerchant(merchant);
        setIsFetchingKycURL(true);
        const response = await merchant.get_kyc_url();
        if (!response.success) {
            setIsFetchingKycURL(false);
            handleApiExceptions(response);
            return;
        }
        window.open(response.data.signed_url, "_blank")
        setIsFetchingKycURL(false);
    };

    const sendPassword = async (merchant = {}) => {
        setSelectedMerchant(merchant);
        setShowResendPassword(true);
        const response = await merchant.send_password();
        if (!response.data.success) {
            setIsSaving(false);
            handleApiExceptions("Something went wrong. Please try again.");
            return;
        }
        alertify("Success", `Password reset link sent successfully.`, "success");
        setShowResendPassword(false);
    }

    const saveMerchant = async (values) => {
        setIsSaving(true);
        const merchant = new Merchant(values);
        const response = await merchant.save();
        if (!response.success) {
            setIsSaving(false);
            handleApiExceptions(response);
            return;
        }
        toggleMerchantModal();
        alertify("Success", `Merchant ${selectedMerchant.is_edit ? "updated" : "created"} successfully.`, "success");
        setIsSaving(false);
        fetchMerchants(pagination, filters);
    };

    const updateMerchantCommision = async (values) => {
        setIsUpdatingCommission(true);
        const merchant = merchants.find(m => m.id == values.id);
        const response = await merchant.update_commission(values);
        if (!response.success) {
            setIsUpdatingCommission(false);
            handleApiExceptions(response);
            return;
        }
        toggleCommissionModal();
        alertify("Success", `Merchant commission updated successfully.`, "success");
        setIsUpdatingCommission(false);
        fetchMerchants(pagination, filters);
    };

    const updateMerchantInstaCommision = async (values) => {
        setIsUpdatingCommission(true);
        const merchant = merchants.find(m => m.id == values.id);
        const response = await merchant.update_insta_commission(values);
        if (!response.success) {
            setIsUpdatingCommission(false);
            handleApiExceptions(response);
            return;
        }
        toggleInstaCommissionModal();
        alertify("Success", `Merchant commission updated successfully.`, "success");
        setIsUpdatingCommission(false);
        fetchMerchants(pagination, filters);
    };

    const uploadMerchantKYC = async (values) => {
        setIsUploadingKYC(true);
        const merchant = merchants.find(m => m.id == values.id);
        const response = await merchant.upload_kyc({ ...values, key: props.current_user.key });
        if (values.id_proof_file && values.id_proof_file.file.type.indexOf("image") == -1) {
            handleApiExceptions("Only Image Extension files are allowed to upload.");
            setIsUploadingKYC(false);
            return;
        }
        if (values.cancelled_cheque_file && values.cancelled_cheque_file.file.type.indexOf("image") == -1) {
            handleApiExceptions("Only Image Extension files are allowed to upload.");
            setIsUploadingKYC(false);
            return;
        }
        if (values.other_doc_file && values.other_doc_file.file.type.indexOf("image") == -1) {
            handleApiExceptions("Only Image Extension files are allowed to upload.");
            setIsUploadingKYC(false);
            return;
        }
        if (!response.success) {
            setIsUploadingKYC(false);
            handleApiExceptions(response);
            return;
        }
        toggleKYCModal();
        alertify("Success", `Merchant KYC uploaded successfully.`, "success");
        setIsUploadingKYC(false);
        fetchMerchants(pagination, filters);
    };

    const getKycData = async (merchant = {}) => {
        setKycMerchantID(merchant.id);
        const response = await merchant.get_kyc_data();
        if (!response.success) {
            setKycMerchantID("");
            handleApiExceptions(response);
            return;
        }
        setKycMerchantID("");
        fetchMerchants(pagination, filters);
    }

    const toggleMerchantModal = (merchant = {}) => {
        setSelectedMerchant(merchant);
        setShowMerchantModal(!showMerchantModal);
    };

    const toggleCommissionModal = (merchant = {}) => {
        setSelectedMerchant(merchant);
        setShowCommissionModal(!showCommissionModal);
    };

    const toggleInstaCommissionModal = (merchant = {}) => {
        setSelectedMerchant(merchant);
        setShowInstaCommissionModal(!showInstaCommissionModal);
    };

    const toggleResendPasswordModal = (merchant = {}) => {
        setSelectedMerchant(merchant);
        setShowResendPasswordModal(!showResendPasswordModal);
    };

    const toggleKYCModal = (merchant = {}) => {
        setSelectedMerchant(merchant);
        setShowKYCModal(!showKYCModal);
    };

    const toggleDetailsDrawer = (merchant = {}) => {
        setSelectedMerchant(merchant);
        setShowDetailsDrawer(!showDetailsDrawer);
    };

    const toggleInsightsDrawer = (merchant = {}) => {
        setSelectedMerchant(merchant);
        setShowInsightsDrawer(!showInsightsDrawer);
    };

    const onCaptchaVerify = () => {
        sendPassword(selectedMerchant)
        toggleResendPasswordModal({});
    }

    const toggleDeactivateModal = (merchant = {}) => {
        setSelectedMerchant(merchant);
        setShowDeactivateModal(!showDeactivateModal)
    }


    const toggleAllotedConnectedBankingDrawer = (merchant = {}) => {
        setSelectedMerchant(merchant);
        setAllotedConnectedBankingDrawer(!showAllotedConnectedBankingDrawer)
    }

    const deactivate_submerchant = async (id) => {
        setDeactivate(true);
        const response = await Merchant.deactivate_merchant({ "is_active": false, "id": id })
        if (!response.success) {
            setDeactivate(false);
            handleApiExceptions(response);
            return;
        }
        setDeactivate(false);
        alertify("Success", response?.data?.message, "success")
        toggleDeactivateModal()
        fetchMerchants(pagination, filters);
    }

    const handleTableChange = (tableInfo) => {
        if (tableInfo.trigger == "columns") return;
        let _pagination = tableInfo.pagination;
        if (tableInfo.trigger == "filters") _pagination.current = 1;
        setPagination(_pagination);
        setFilters(tableInfo.filters);
        fetchMerchants(_pagination, tableInfo.filters);
    };

    const tableColumns = getMerchantsTableColumns({
        toggleMerchantModal,
        toggleCommissionModal,
        toggleInstaCommissionModal,
        toggleKYCModal,
        toggleDetailsDrawer,
        toggleInsightsDrawer,
        sendPassword,
        toggleResendPasswordModal,
        openKYCPage,
        getKycData,
        toggleDeactivateModal,
        deactivate_submerchant,
        toggleAllotedConnectedBankingDrawer,
        kycMerchantID,
        is_enable_fund_allotment
    });
    const tableFilters = merchantsFilterNodes;


    useEffect(() => {
        props.onChildMount();
        fetchMerchants({ ...pagination }, { ...filters });
    }, []);

    const onPageChange = (_pagination) => {
        setPagination({ ..._pagination });
        fetchMerchants({ ..._pagination }, filters);
    };

    return (
        props.current_user.is_reseller ?
            <Spin tip='Please Wait...' spinning={isFetchingKycURL}>
                <ContentCard className="p-3">
                    <div className=" d-flex justify-content-between">
                        <Descriptions column={1} bordered className='mr-2'>
                            <Descriptions.Item label={"Merchant Login URL"} className='w-100 d-flex justify-content-center'>
                                <Text4 copyable >{props?.current_user?.white_label_setting?.login_url ?? '---'}</Text4>
                            </Descriptions.Item>
                        </Descriptions>
                        <CreatePermissableButton type="primary" onClick={toggleMerchantModal}>
                            <Icon type="plus" /> New Merchant
                        </CreatePermissableButton>
                    </div>
                    <EaseTable
                        rowKey="id"
                        loading={isTableLoading}
                        data={merchants}
                        columns={tableColumns}
                        fixedSelectable={!isMobile}
                        handleTableChange={handleTableChange}
                        // pagination={pagination}
                        // totalRecords={pagination.total}
                        filterNodes={tableFilters}
                    /><PaginationKaBaap pageChange={onPageChange} pagination={pagination} />
                    <MerchantModal
                        visible={showMerchantModal}
                        toggleMerchantModal={toggleMerchantModal}
                        merchant={selectedMerchant}
                        saveMerchant={saveMerchant}
                        loading={isSaving}
                    />
                    <CommissionModal
                        visible={showCommissionModal}
                        toggleCommissionModal={toggleCommissionModal}
                        merchant={selectedMerchant}
                        onSubmit={updateMerchantCommision}
                        loading={isUpdatingCommission}
                    />
                    <InstaCommissionModal
                        visible={showInstaCommissionModal}
                        toggleInstaCommissionModal={toggleInstaCommissionModal}
                        merchant={selectedMerchant}
                        onSubmit={updateMerchantInstaCommision}
                        loading={isUpdatingCommission}
                    />
                    {/* <KYCModal
                        title="Upload Merchant KYC"
                        visible={showKYCModal}
                        toggleKYCModal={toggleKYCModal}
                        merchant={selectedMerchant}
                        onSubmit={uploadMerchantKYC}
                        loading={isUploadingKYC}
                    /> */}
                    <MerchantDetailsDrawer
                        visible={showDetailsDrawer}
                        toggleDetailsDrawer={toggleDetailsDrawer}
                        toggleKYCModal={toggleKYCModal}
                        merchant={selectedMerchant}
                    />
                    <MerchantInsightsDrawer
                        visible={showInsightsDrawer}
                        toggleInsightsDrawer={toggleInsightsDrawer}
                        merchant={selectedMerchant}
                    />
                    <ResendPasswordModal
                        visible={showResendPasswordModal}
                        merchant={selectedMerchant}
                        onCaptchaVerify={onCaptchaVerify}
                        toggleResendPasswordModal={toggleResendPasswordModal}
                    />
                    <DeactivateMerchantModal
                        visible={showDeactivateModal}
                        merchant={selectedMerchant}
                        toggleDeactivateModal={toggleDeactivateModal}
                        deactivate_submerchant={deactivate_submerchant}
                    />
                    <AllotedConnectedBankingDrawer
                        visible={showAllotedConnectedBankingDrawer}
                        toggleAllotedConnectedBankingDrawer={toggleAllotedConnectedBankingDrawer}
                        merchant={selectedMerchant}
                        fetchMerchants={fetchMerchants}
                    />
                </ContentCard>
            </Spin>
            :
            <Alert
                message="Error"
                description="You are not authorised to view this page."
                type="error"
                showIcon
            />
    )
};

const mapStateToProps = state => ({
    current_user: state.userReducer.current_user
});

const mapDispatchToProps = dispatch => ({
    updateCurrentUser: user => dispatch(updateCurrentUserAction(user))
});

export default connect(mapStateToProps, mapDispatchToProps)(PermissionHoc(MerchantList, 'MERCHANTS_READ'));